import { createAction, props } from '@ngrx/store';
import { Map } from 'immutable';

import { CurrentUser } from '../domain/current-user';
import { Features } from '../domain/features';
import { InstanceModule } from '../domain/instance-module';
import { Organization } from '../domain/organization';
import { LanguagePreference, Preferences } from '../domain/preferences';

export enum CoreAction {
	GetCurrentOrganization = '[Core] Get current organization',
	SetCurrentOrganization = '[Core] Set current organization',
	GetCurrentOrganizationSuccess = '[Core] Get current organization success',
	GetCurrentOrganizationFail = '[Core] Get current organization fail',
	GetCurrentUser = '[Core] Get current user',
	GetCurrentUserSuccess = '[Core] Get current user success',
	GetCurrentUserFail = '[Core] Get current user fail',
	GetConnectedUserDetailsSuccess = '[BE][Core] Get connected user details (instance modules, organization) success',
	GetConnectedUserDetailsFail = '[BE][Core] Get connected user details (instance modules, organization) fail',
	NavigateToMyAccount = '[Core] Navigate to my account',
	SetAppLanguage = '[Core] Sync stored language config with user preference',
}

export const getCurrentOrganization = createAction(
	CoreAction.GetCurrentOrganization,
	props<{ orgId: number }>(),
);

export const setCurrentOrganization = createAction(
	CoreAction.SetCurrentOrganization,
	props<{ orgId: number }>(),
);

export const getCurrentOrganizationSuccess = createAction(
	CoreAction.GetCurrentOrganizationSuccess,
	props<{ organization: Organization }>(),
);

export const getCurrentOrganizationFail = createAction(
	CoreAction.GetCurrentOrganizationFail,
	props<{ error: unknown }>(),
);

export const getDetailsForConnectedUser = createAction(
	CoreAction.GetCurrentUserSuccess,
	props<{ user: CurrentUser }>(),
);

export const getDetailsForConnectedUserSuccess = createAction(
	CoreAction.GetConnectedUserDetailsSuccess,
	props<{
		defaultOrganizationId: number;
		instanceModules: Map<string, InstanceModule>;
		organizationPerUserAccount: Map<number, Organization>;
		preferences: Preferences;
		features: Features;
	}>(),
);

export const setAppLanguage = createAction(
	CoreAction.SetAppLanguage,
	props<{ lang: LanguagePreference }>(),
);

export const getDetailsForConnectedUserFail = createAction(
	CoreAction.GetConnectedUserDetailsFail,
	props<{ error: unknown }>(),
);

export const navigateToMyAccount = createAction(CoreAction.NavigateToMyAccount);
